var Sample = /** @class */ (function () {
    function Sample(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        this.brand = obj.brand;
        this.packaging = obj.packaging;
        this.status = obj.status;
        this.position = obj.position;
        this.position = obj.position;
        this.image_url = obj.image_url;
        this.external_id = obj.external_id;
    }
    Object.defineProperty(Sample.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sample.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sample.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sample.prototype, "Brand", {
        get: function () {
            return this.brand;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sample.prototype, "Packaging", {
        get: function () {
            return this.packaging;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sample.prototype, "Status", {
        get: function () {
            return this.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sample.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sample.prototype, "ImageUrl", {
        get: function () {
            return this.image_url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sample.prototype, "ExternalId", {
        get: function () {
            return this.external_id;
        },
        enumerable: false,
        configurable: true
    });
    return Sample;
}());
export { Sample };
export function createSample(obj, id) {
    return new Sample(obj, id);
}
export function createSamples(rawSamples) {
    var samples = [];
    var rawSamplesData = rawSamples.data;
    for (var _i = 0, rawSamplesData_1 = rawSamplesData; _i < rawSamplesData_1.length; _i++) {
        var rawSample = rawSamplesData_1[_i];
        var sample = createSample(rawSample.attributes, rawSample.id);
        samples.push(sample);
    }
    return samples;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/sample/sample.ts
// module id = 130
// module chunks = 0